module.exports = __webpack_public_path__ + "assets/kucoin-white.240e1168.svg";